import search from './search';
import metaInfo from './metaInfo';

export default (config) => ({
  search: search(config),
  metaInfo,
  filterExpanded: (state, getters, rootState) => (name) => {
    const includes = state.toggledFilterMenus.includes(name);
    return rootState.root.isMobile ? includes : !includes;
  },
});
